var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSignature = function SvgSignature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".signature_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.916 16.872a2.473 2.473 0 1 1 4.571 1.88c-.519 1.263-4.167 3.631-4.167 3.631s-.92-4.249-.404-5.511M14.843 18.684l-1.523 3.699",
    className: "signature_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.325 14.683 3.044-7.394 3.698 1.522-3.043 7.394zM19.651 1.739a2 2 0 0 0-2.61 1.089L14 10.225",
    className: "signature_svg__a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.651 1.74a2 2 0 1 1 3.7 1.521L21.067 8.81l-3.7-1.521ZM.5 23.174a4.392 4.392 0 0 1 2.933-1.1c1.758 0 4.864 2.847 7.7.5",
    className: "signature_svg__a"
  })));
};
export default SvgSignature;